"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const getAllPaths = /(\/:?[\w-]{1,})|\//g;
class Router {
    constructor({ pathname } = { pathname: window.location.pathname }) {
        this.routes = [];
        this.pathname = pathname;
    }
    getRoutes() {
        return this.routes;
    }
    createUrlWithParams(path, url) {
        const pathList = path.match(getAllPaths) || [];
        const urlList = url.match(getAllPaths) || [];
        const urlWithParams = {
            url: '',
            parameters: {}
        };
        if (pathList.length === urlList.length) {
            /**
             * create new url
             */
            pathList.forEach((group, index) => {
                if (group === urlList[index]) {
                    urlWithParams.url += urlList[index];
                }
                else {
                    const res = urlList[index].replace(/\/:\w{1,}/g, group);
                    urlWithParams.url += res;
                    const propertyKey = urlList[index].replace(/(\/:|\/)/gi, '');
                    const parameterValue = res.replace(/(\/)/gi, '');
                    urlWithParams.parameters[propertyKey] = parameterValue;
                }
            });
        }
        return urlWithParams;
    }
    matchUrl(url) {
        const pathnameNormalized = this.normalizeUrl(this.pathname);
        const urlNormalized = this.normalizeUrl(url);
        const routeData = this.createUrlWithParams(pathnameNormalized, urlNormalized);
        const regEx = new RegExp(`^${routeData.url}$`);
        if (pathnameNormalized.match(regEx)) {
            return routeData;
        }
        return null;
    }
    normalizeUrl(route) {
        const getSlashEndUrl = /\/(?:$|(\?.*))/;
        return route === '/' ? route : route.replace(getSlashEndUrl, '$1');
    }
    /**
     * when pathname is identical to the url passed by parameter,
     * executes callback function and returns true
     * (otherwise returns false or error message)
     */
    get(path, callback) {
        const route = {
            path,
            callback
        };
        this.routes.push(route);
    }
    init() {
        let routeIsMatched = false;
        this.routes.forEach((route) => {
            /**
             * pathname e url must be exactly the same
             */
            if (Array.isArray(route.path)) {
                route.path.forEach((path) => {
                    const routeData = this.matchUrl(path);
                    if (routeData) {
                        route.callback(routeData);
                        routeIsMatched = true;
                    }
                });
            }
            else {
                const routeData = this.matchUrl(route.path);
                if (routeData) {
                    route.callback(routeData);
                    routeIsMatched = true;
                }
            }
        });
        return routeIsMatched;
    }
}
exports.default = Router;
//# sourceMappingURL=router.js.map